import { Shipment } from 'models/Shipment.model';
import {
  ReturnTicket,
  ShipmentDocument,
  OrgCarrierConfig,
  MapType,
} from '@pperform/pp-data-mappers';

enum ShipmentDocFileFormat {
  QR = 'QR',
}

class ReturnShipment extends Shipment {
  @MapType([ReturnTicket])
  returnTickets: ReturnTicket[] = [];

  @MapType(OrgCarrierConfig)
  orgCarrierConfig: OrgCarrierConfig = new OrgCarrierConfig();

  isNoInfoAvailable = false;

  get returnTicket(): ReturnTicket {
    return this.returnTickets?.[0] ?? new ReturnTicket();
  }

  getQRDocument(): ShipmentDocument | undefined {
    const QRDocument = this.shipmentDocuments?.find(
      (document) => document.fileFormat === ShipmentDocFileFormat.QR,
    );

    return QRDocument;
  }

  hasPickupEvents(): boolean {
    return this.mixedEvents.some(
      (event) => event.eventTypeMasterData?.eventPhase.key === 'D',
    );
  }

  hasPhaseDOrLater(): boolean {
    return !!this.parcel?.events?.some(
      (event) =>
        event.eventTypeMasterData?.eventPhase.key === 'D' ||
        event.eventTypeMasterData?.eventPhase.key === 'E' ||
        event.eventTypeMasterData?.eventPhase.key === 'F' ||
        event.eventTypeMasterData?.eventPhase.key === 'G' ||
        event.eventTypeMasterData?.eventPhase.key === 'H' ||
        event.eventTypeMasterData?.eventPhase.key === 'I',
    );
  }

  isBookingValidationFailed(): boolean {
    return this.latestMixedEvent.eventType === 'Booking validation failed';
  }
}

export { ReturnShipment };
